module.exports = {
      id: "video-play-usage",
      viewBox: "0 0 58.316 58.344",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#video-play",
      toString: function () {
        return this.url;
      }
    }